import { Link } from 'react-router-dom';
import type { BlogPostMeta } from '../types/blog';

interface RelatedPostsProps {
  posts: BlogPostMeta[];
}

export default function RelatedPosts({ posts }: RelatedPostsProps) {
  if (posts.length === 0) return null;

  return (
    <section>
      <h2 className="text-lg font-bold mb-6 text-white">Keep Reading</h2>
      <ul className="space-y-4">
        {posts.map((post) => (
          <li key={post.slug}>
            <Link
              to={`/blog/${post.slug}`}
              className="block rounded-xl bg-white/5 hover:bg-white/10 transition-colors p-5 group"
            >
              <h3 className="font-bold text-white group-hover:text-primary transition-colors mb-1">
                {post.title}
              </h3>
              <p className="text-slate-400 text-sm line-clamp-2 mb-2">
                {post.description}
              </p>
              <span className="text-slate-500 text-xs">{post.readingTime} min read</span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
